import axiosInstance from '../api';

export interface RevaChip {
  label: string;
  question: string;
  /** An in-app route that answers the chip better than a chat turn; navigate instead of asking. */
  href?: string;
}

export interface RevaBriefing {
  greeting: string;
  dateLabel: string;
  summary: string;
  chips: RevaChip[];
  /** What Reva is grounded in for this user, e.g. "your search", "offer on 312 Highland". */
  knows: string[];
  hasActivity: boolean;
  /** Which side(s) the briefing covers: what the customer is buying, selling, both, or neither yet. */
  side: 'buying' | 'selling' | 'both' | 'none';
}

const revaBriefingService = {
  getBriefing: async (): Promise<RevaBriefing> => {
    const res = await axiosInstance.get<RevaBriefing>('/reva-briefing');
    return res.data;
  },
};

export default revaBriefingService;
